import type { Type } from "@warp-drive/core/types/symbols";

export interface V2Patient {
  [Type]: "patients";
  id: string;
  followUpReason: string;
  disenrolledOn: Date;
  enrolledOn: Date;
  mrcStage: string;
  dialysisType: string;
  isProIrcIncluded: string;
  fullName: string;
  configuratorHealthCentreName: string;
  supportHealthCentreName: string;
  referentMedicName: string;
  supportMedicName: string;
  lastConsultationOn: Date;
  lastConsultationId: string;
  phone: string;
  email: string;
  lastName: string;
}

// prettier-ignore
export const PatientSchema = {
  type: "patients",
  identity: { kind: "@id", name: "id" },
  legacy: true,
  fields: [
    { name: "followUpReason", sourceKey: "follow-up-reason", kind: "field" },
    { name: "disenrolledOn", sourceKey: "disenrolled-on", kind: "field" },
    { name: "enrolledOn", sourceKey: "enrolled-on", kind: "field" },
    { name: "mrcStage", sourceKey: "mrc-stage", kind: "field" },
    { name: "dialysisType", sourceKey: "dialysis-type", kind: "field" },
    { name: "isProIrcIncluded", sourceKey: "is-pro-irc-included", kind: "field" },
    { name: "fullName", sourceKey: "full-name", kind: "field" },
    { name: "configuratorHealthCentreName", sourceKey: "configurator-health-centre-name", kind: "field" },
    { name: "supportHealthCentreName", sourceKey: "support-health-centre-name", kind: "field" },
    { name: "referentMedicName", sourceKey: "referent-medic-name", kind: "field" },
    { name: "supportMedicName", sourceKey: "support-medic-name", kind: "field" },
    { name: "lastConsultationOn", sourceKey: "last-consultation-on", kind: "field" },
    { name: "lastConsultationId", sourceKey: "last-consultation-id", kind: "field" },
    { name: "phone", sourceKey: "phone", kind: "field" },
    { name: "email", sourceKey: "email", kind: "field" },
    { name: "lastName", sourceKey: "last-name", kind: "field" },
    { name: "isDestroying", sourceKey: "is-destroying", kind: "field" },
    { name: "isDestroyed", sourceKey: "is-destroyed", kind: "field" }
  ]
};
